import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton, PrismSelectInput } from '@mylighthouse/prism-ember';
import type { Option } from '@mylighthouse/prism-ember/types/components/prism/select-input';
import { t } from 'ember-intl';
import {
  SMART_INSIGHTS_ARCHIVE_REASON_TRANSLATIONS,
  SMART_INSIGHTS_ARCHIVE_REASONS,
  type SmartInsightsArchiveReason,
} from 'lumen/utils/constants/smart-insights';

import styles from './dropdown-archive.module.css';

interface GeneralSmartInsightsDetailViewDropdownArchiveSignature {
  Args: {
    isArchiving?: boolean;
    onArchive: (reason: SmartInsightsArchiveReason) => void;
  };
}

type ArchiveOption = Option & {
  label: string;
  value: SmartInsightsArchiveReason;
};

export default class GeneralSmartInsightsDetailViewDropdownArchive extends Component<GeneralSmartInsightsDetailViewDropdownArchiveSignature> {
  @service declare intl: Services['intl'];

  get options(): ArchiveOption[] {
    return Object.values(SMART_INSIGHTS_ARCHIVE_REASONS).map((reason) => ({
      label: this.intl.t(SMART_INSIGHTS_ARCHIVE_REASON_TRANSLATIONS[reason]),
      value: reason,
    }));
  }

  @action onChange(option: ArchiveOption): void {
    this.args.onArchive(option.value);
  }

  <template>
    <div class="ic-product-tour-57546189-smart-insights-archive">
      {{#if @isArchiving}}
        <PrismButton
          @isDisabled={{true}}
          @isLoading={{true}}
          @isSmall={{true}}
          @label={{t "smart_insights.archive.button_label"}}
          data-test-id="dropdown-archive-loading"
        />
      {{else}}
        <div class={{styles.dropdown}}>
          <PrismSelectInput
            @isSmall={{true}}
            @onChange={{this.onChange}}
            @options={{this.options}}
            @placeholder={{t "smart_insights.archive.button_label"}}
            data-test-id="dropdown-archive"
          />
        </div>
      {{/if}}
    </div>
  </template>
}
